import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { BrowserRouter } from "react-router-dom";
import "./styles.css";
import "./i18n";
import App from "./App";
import { LocalizedApp } from "./components/LocalizedApp";

createRoot(document.getElementById("root")!).render(
  <StrictMode>
    <BrowserRouter>
      <LocalizedApp>
        <App />
      </LocalizedApp>
    </BrowserRouter>
  </StrictMode>,
);
